import {
  Box,
  Button,
  Stack,
  TextField,
  Typography,
  Container,
  Divider,
} from "@mui/material";
import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { createProject } from "../../apis/apiList/projectApi";
import { useMessage } from "../../context/MessageContext";
import { useNavigate } from "react-router-dom";

const validationSchema = Yup.object({
  projectName: Yup.string().required("Project Name is required"),
  topic1: Yup.string().required("Topic #1 is required"),
});

export const AddProject = ({ handleAddProjectShow, organization }) => {
    const {showMessage} =useMessage();
    const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      projectName: "",
      topic1: "",
      topic2: "",
      topic3: "",
      topic4: "",
      topic5: "",
    },
    validationSchema,
    onSubmit: (values) => {
      console.log("Form Submitted:", values);
      console.log("organization:", organization);
      let openingTopics = [{topicNumber: `opening`, text: '',}]
      let closingTopics = [{topicNumber: `closing`, text: '',}]
      let otherTopics = [5, 4, 3, 2, 1].map((num) => ({
        topicNumber: `topic ${num}`,
        text: values[`topic${num}`],
      }));

      let topics = [ ...openingTopics, ...otherTopics, ...closingTopics ];

      let data = {
        projectName: values.projectName,
        boxFolderId: organization.boxFolderId,
        orgId: organization._id,
        vimeoFolderUri: organization.vimeoUri,
        topics: topics,
      };
      console.log("project data", data);

      handleCreateProject(data)
    },
  });

  const handleCreateProject = async (data)=>{
    try {
        const prjResponse = await createProject(data)
        console.log('prjResponse', prjResponse);
        if(prjResponse?.success){
            showMessage(prjResponse.message, 'success')
            navigate(`/org/${prjResponse.data.orgId}/project/view/${prjResponse.data._id}`)
        }
    } catch (err) {
        console.log(err);
        showMessage(err?.response?.data?.message || 'Something went wrong', 'error');
    }
  }

  const btnDesign = { mt: 3, px: 4, py: 1, borderRadius: "10px" };
  return (
    <Box px={3} py={1.5}>
      <Stack direction={"column"}>
        <Box sx={{ mb: 2 }}>
          <Typography variant="h2">Create Project</Typography>
        </Box>

        <Divider />
        <form onSubmit={formik.handleSubmit}>
          <Box
            sx={{
              //   textAlign: "center",
              mt: 3,
              //   p: 3,
              //   border: "2px solid black",
              //   borderRadius: "12px",
              backgroundColor: "#f9f9f9",
              //   boxShadow: "4px 4px 0px rgba(0,0,0,0.5)",
            }}
          >
            <Box mb={4}>
              <label>Project Name</label>
              <TextField
                variant="outlined"
                fullWidth
                placeholder="eg. January 2025 snapshot video"
                name="projectName"
                value={formik.values.projectName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.projectName &&
                  Boolean(formik.errors.projectName)
                }
                helperText={
                  formik.touched.projectName && formik.errors.projectName
                }
              />
            </Box>

            <Box>
              <label>Add top 5 topics</label>
              {/* Text Fields */}
              {[5, 4, 3, 2, 1].map((num) => (
                <TextField
                  key={num}
                  variant="outlined"
                  fullWidth
                  label={`#${num}`}
                  name={`topic${num}`}
                  value={formik.values[`topic${num}`]}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched[`topic${num}`] &&
                    Boolean(formik.errors[`topic${num}`])
                  }
                  helperText={
                    formik.touched[`topic${num}`] &&
                    formik.errors[`topic${num}`]
                  }
                  sx={{
                    mt: 2,
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "10px",
                      backgroundColor: "white",
                    },
                  }}
                />
              ))}
            </Box>

            {/* Button */}
            <Stack direction={"row"} gap={2}>
              <Button variant="contained" type="submit" sx={btnDesign}>
                Add project
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  handleAddProjectShow();
                }}
                sx={btnDesign}
              >
                Cancel
              </Button>
            </Stack>
          </Box>
        </form>
      </Stack>
    </Box>
  );
};
